import React, { useCallback, useEffect, useState } from "react";
import Modal from "react-modal";
import ButtonPrimary from "../ButtonPrimary";
import { InputModal } from "../InputModal";
import { Box, ContainerModal, Text, TextArea } from "./styles";
import { AnimatePresence, motion } from "framer-motion";
import api from "../../../../services/api";
import { useModalContext } from "../../../../hooks/modalContext";
import { useToolbarEditor } from "../../hooks/toolbarEditor";
import { useClausesEditor } from "../../hooks/clausesEditor";
import { LoadingFlex } from "../../../login/pages/Login/styles";
import PuffLoader from "react-spinners/PuffLoader";
import { toast } from "react-toastify";

interface NewClausesModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  idClause?: string;
  refreshClause?: boolean;
  setRefreshClause?: React.Dispatch<React.SetStateAction<boolean>>;
  indexClause?: number;
}

interface SpecificClauseProps {
  clause?: string;
  created_at?: string;
  description?: string;
  id?: string;
  is_favorite?: boolean;
  key_words?: string;
  title?: string;
  updated_at?: string;
  user_id?: string;
}

interface ObjectClauseUpdate {
  user_clause_id: string;
  title: string;
  clause: string;
  description: string;
  is_favorite: boolean;
  key_words?: string;
}

export const EditClauseModal: React.FC<NewClausesModalProps> = ({
  isOpen,
  onRequestClose,
  idClause,
  refreshClause,
  setRefreshClause,
  indexClause
}) => {
  const {
    setColorToElement,
    blockCommandKeyboard,
    setBlockCommandKeyboard,
    forceBlockKey,
    setForceBlockKey
  } = useToolbarEditor();

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      scale: 1.2,
      transition: {
        delayChildren: 0.5,
        type: "spring",
        duration: 1,
        stiffness: 100,
        staggerDirection: -1
      }
    }
  };

  const item = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        delayChildren: 1.9,
        type: "spring",
        stiffness: 100
      }
    }
  };

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const autoLoadClause = async () => {
      if (idClause !== "") {
        try {
          const responseClauseSpecific = await api.get(
            `user-clause/${idClause}`
          );

          setMyClause(responseClauseSpecific.data);
        } catch (err) {
          console.log(err, "error when trying fetch data specific clause");
        }
      }
    };

    autoLoadClause();
  }, [idClause]);

  const [myClause, setMyClause] = useState<SpecificClauseProps>({});
  const { clausesData, setClausesData } = useClausesEditor();

  const [objectFormatted, setObjectFormatted] = useState<ObjectClauseUpdate>({
    user_clause_id: "",
    title: "",
    clause: "",
    description: "",
    is_favorite: false
  });

  const onChangeTitleMyClause = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      setMyClause(state => {
        return {
          ...state,
          title: event.target.value
        };
      });
    },
    []
  );

  const onChangeTextClause = useCallback(
    (event: React.ChangeEvent<HTMLTextAreaElement>) => {
      setMyClause(state => {
        return {
          ...state,
          clause: event.target.value
        };
      });
    },
    []
  );

  const handleSubmitEditingMyClause = useCallback(
    async event => {
      event.preventDefault();

      if (
        objectFormatted.user_clause_id === idClause &&
        objectFormatted.user_clause_id !== ""
      ) {
        try {
          setLoading(true);
          const responseUpdateClause = await api.put(
            "user-clause",
            objectFormatted
          );

          setClausesData(state => {
            let cloneState = [...state];

            let editingClause = cloneState.map(clause => {
              if (clause.id === idClause) {
                return {
                  ...clause,
                  title: objectFormatted.title,
                  description: objectFormatted.description,
                  clause: objectFormatted.clause
                };
              } else {
                return {
                  ...clause
                };
              }
            });

            return editingClause;
          });
          toast.success("Clausula editada com sucesso!");
          setLoading(false);
        } catch (err) {
          console.log(err, "error");
          toast.error("Algo inesperado aconteceu.");
          setLoading(false);
        }
      }
      setObjectFormatted(state => {
        return {
          ...state,
          user_clause_id: "",
          title: "",
          clause: "",
          description: "",
          is_favorite: false
        };
      });

      setRefreshClause(!refreshClause);
      onRequestClose();
    },
    [myClause, objectFormatted, refreshClause, clausesData]
  );

  useEffect(() => {
    setObjectFormatted(state => {
      let cloneState = { ...state };
      cloneState.user_clause_id = myClause.id;
      cloneState.title = myClause.title;
      cloneState.clause = myClause.clause;
      cloneState.description = myClause.description;
      cloneState.is_favorite = myClause.is_favorite;

      return cloneState;
    });
  }, [myClause]);

  useEffect(() => {
    if (isOpen) {
      setForceBlockKey(true);
    } else {
      setForceBlockKey(false);
    }
  }, [isOpen]);

  return (
    <Modal
      className="react-modal-content"
      overlayClassName="react-modal-overlay"
      isOpen={isOpen}
      onRequestClose={onRequestClose}
    >
      <AnimatePresence>
        <ContainerModal
          as={motion.form}
          initial="hidden"
          animate="show"
          variants={container}
          exit={{
            opacity: 0,
            scale: 0.8,
            x: -300
          }}
          transition={{ duration: 1 }}
        >
          <InputModal
            borderBottom="1px solid"
            height="40px"
            textTransform="uppercase"
            value={myClause?.title}
            name="title"
            borderColor="#A5a5a5"
            onChange={onChangeTitleMyClause}
          />
          <TextArea
            as={motion.textarea}
            variants={item}
            value={myClause?.clause}
            onChange={onChangeTextClause}
          ></TextArea>
          <ButtonPrimary
            className="force-remove-margin"
            onClick={handleSubmitEditingMyClause}
          >
            {loading ? (
              <LoadingFlex>
                <PuffLoader color="#ffff" size="28" />
              </LoadingFlex>
            ) : (
              `Editar`
            )}
          </ButtonPrimary>
        </ContainerModal>
      </AnimatePresence>
    </Modal>
  );
};
